module.exports = __webpack_public_path__ + "img/icn_check_tsumekiri.b509f2e3.png";